import dayjs from "dayjs"
import i18n from "i18next"
import { Uuid } from "types/global"


export const getLetters = (start: number, length = 1) =>
	Array.from({ length }, (_, index) => String.fromCharCode(start + index + 65))

export function dateFormat(date: string | number | Date | dayjs.Dayjs) {
	if (!date) return ""
	return dayjs(date).format("DD/MM/YYYY")
}
export function dateTimeFormat(date: string | number | Date | dayjs.Dayjs) {
	if (!date) return ""
	return dayjs(date).format("DD/MM/YYYY HH:mm")
}

export const monthName = (index: number, short = false) => {
	return i18n.t(`app.months${short ? "_short" : ""}.${index}`)
}
export const monthNameShort = (index: string | number) => {
	return i18n.t(`app.months.${index}`)
}

export function getRef(uuid: Uuid) {
	return uuid?.split("-")?.[0] ?? ""
}

export function insertIndex(name: string): string {
	let index = 1
	const regex = /\((\d+)\)$/
	const match = name.match(regex)
	if (match) {
		index = parseInt(match[1]) + 1
		return name.replace(regex, `(${index})`)
	}
	return `${name}(${index})`
}

export const formatTime = (mins: number) => {
	const h = Math.floor(mins / 60).toString().padStart(2, '0')
	const m = Math.floor(mins % 60).toString().padStart(2, '0')
	return `${h}:${m}`
}